import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {adTypesRadio} from '../../../constants';
import CustomRadio from '../../../../../../components/mazraeKit/customRadio';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from '../../../../../../store/redux';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';

interface IAdvertisementTypesBottomSheet {
  openAdvertisementTypeBottomSheet: boolean;
  setOpenAdvertisementTypeBottomSheet: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

function AdvertisementTypesBottomSheet({
  openAdvertisementTypeBottomSheet,
  setOpenAdvertisementTypeBottomSheet,
}: IAdvertisementTypesBottomSheet) {
  const dispatch = useDispatch();
  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  return (
    <BottomSheet
      onDismiss={() => setOpenAdvertisementTypeBottomSheet(false)}
      open={openAdvertisementTypeBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col gap-3 px-3 pb-3">
        {adTypesRadio.map(item => (
          <CustomRadio
            {...item}
            name="radio"
            key={item.value}
            value={item.value}
            checked={item.value === state?.ad_type?.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              dispatch(
                addRegisterAdvertisement({
                  ad_type: {title: item.title, value: e.target.value},
                }),
              );
              setOpenAdvertisementTypeBottomSheet(false);
            }}
          />
        ))}
      </div>
    </BottomSheet>
  );
}

export default React.memo(AdvertisementTypesBottomSheet);
